import CssBaseline from '@material-ui/core/CssBaseline';
import React from 'react';
import ReactDOM from 'react-dom';
import { initializeLoading } from './utils/showLoading';

import App from './App';

const finishLoading = initializeLoading();

setTimeout(() => {
  try {
    finishLoading();
  } catch (error) {
    console.error('Erro ao finalizar loading:', error);

    const splash = document.getElementById('splash-screen');

    if (splash) {
      splash.remove();
    }
  }
}, 2000);

ReactDOM.render(
  <CssBaseline>
    <App />
  </CssBaseline>,
  document.getElementById('root')
);
